<template>
	<section>
		<Form :model="stopSheetForm" inline>
			<Row>
				<FormItem label="创建日期：" prop="createDate" :label-width="84">
					<DatePicker v-model="stopSheetForm.createDate" @on-change="dateRange => {changeDate(dateRange, 'stopSheetForm', 'createDate')}" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
				</FormItem>
				<FormItem label="预停用日期范围：" prop="expectedStopDate" :label-width="125">
					<DatePicker v-model="stopSheetForm.expectedStopDate" @on-change="dateRange => {changeDate(dateRange, 'stopSheetForm', 'expectedStopDate')}" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
				</FormItem>
			</Row>
			<Row>
				<FormItem prop="city" label="城市：" :label-width="80">
					<Select v-model="stopSheetForm.city" @on-change="clearValue('city')" clearable filterable>
						<Option v-for="(city, index) in allCities" :key="index" :value="city">{{city}}</Option>
					</Select>
				</FormItem>
				<!-- <FormItem prop="hotSpot" label="热点：" :label-width="80">
          <Select v-model="stopSheetForm.hotSpot" @on-change="clearValue('hotSpot')" clearable filterable>
            <Option v-for="hotSpot in hotSpots" :key="hotSpot.sourceId" :value="hotSpot.sourceId">{{hotSpot.sourceName}}</Option>
          </Select>
        </FormItem> -->
				<FormItem prop="hotel" label="门店：" :label-width="80">
					<Select v-model="stopSheetForm.hotel" clearable filterable>
						<Option v-for="hotel in hotels" :key="hotel.sourceId" :value="hotel.sourceId">{{hotel.sourceName}}</Option>
					</Select>
				</FormItem>
				<FormItem prop="room" label="房间：" :label-width="80">
					<Input type="text" v-model="stopSheetForm.room" placeholder="输入id或者展示房号"></Input>
				</FormItem>
			</Row>
			<Row>
				<FormItem prop="stopNo" label="停用单号：" :label-width="84">
					<Input type="text" v-model="stopSheetForm.stopNo" placeholder="请输入关键字"></Input>
				</FormItem>
				<FormItem prop="type" label="停用类型：" :label-width="84">
					<Select v-model="stopSheetForm.type" filterable>
						<Option v-for="(typeName, index) in type" :key="index" :value="index">{{typeName}}</Option>
					</Select>
				</FormItem>
				<FormItem prop="state" label="状态：" :label-width="80">
					<Select v-model="stopSheetForm.state" filterable>
						<Option value="S00">全部</Option>
						<Option :value="0">新建</Option>
						<Option :value="1">开始</Option>
						<Option :value="2">结束</Option>
						<Option :value="3">停用取消(已开始)</Option>
						<Option :value="4">未开始取消</Option>
					</Select>
				</FormItem>
			</Row>
			<Row>
				<FormItem prop="stopSheetQuery">
					<Button type="primary" @click="queryStopSheetListWithKeyword">查询</Button>
				</FormItem>
				<FormItem prop="export">
					<Button type="primary" @click="exportFilterResult" :loading="exportBtn">导出筛选结果</Button>
				</FormItem>
				<FormItem prop="export">
					<Button type="primary" @click="modifyInBatch">批量新增停用单</Button>
				</FormItem>
			</Row>
		</Form>
		<Table stripe :loading="stopSheetList.loading" :columns="stopSheetColumn" :data="stopSheetList.data"></Table>
		<div style="margin: 10px;overflow: hidden">
			<Page show-sizer placement="top" :total="stopSheetList.count" :current="stopSheetList.page" :page-size="stopSheetList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
		</div>
	</section>
</template>

<script>
import Moment from "moment"
import Utils from "../../utils";
import API from "../../api";
import Config from "../../config";
export default {
	created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
	},
	async mounted() {
		this.$Notice.config( {
			top: 200
		} );
		this.hotspotPowerIds = ( await API.omsAPI[this.env].php.getHotSpotIds() ).data.toString();
		let selectListResp = ( await API.omsAPI[this.env].php.querySelectList() ).data;
		this.allCities = selectListResp.data.city;
		this.allHotSpots = selectListResp.data.hotspot;
		this.allHotels = selectListResp.data.chain;
		this.queryStopSheetList();
	},
	data() {
		let defaultDate = [
			Moment().subtract( 29, 'day' ).format( "YYYY-MM-DD" ),
			Moment().format( "YYYY-MM-DD" ),
		];
		return {
			exportBtn: false,
			type: ["全部", "待解约停用", "设施维修停用", "长租房停用", "参观停用", "预订停用", "其它原因"],
			stopSheetColumn: [
				{
					title: "停用单号",
					key: "stopNo",
					align: "center",
					width: 300
				},
				{
					title: "门店名称",
					key: "chainName",
					align: "center",
					width: 300
				},
				{
					title: "房间id",
					key: "roomId",
					align: "center",
					width: 100
				},
				{
					title: "房间号",
					key: "roomNo",
					align: "center",
					width: 200
				},
				{
					title: "预计停用时间",
					key: "stopTime",
					align: "center",
					width: 250,
					render: ( h, params ) => {
						let beginDate = params.row.beginDate ? params.row.beginDate : "";
						let endDate = params.row.endDate ? params.row.endDate : "";
						return h(
							"div",
							[
								h( "p", {
									style: {
										textAlign: "left"
									}
								}, `开始：${ beginDate }` ),
								h( "p", {
									style: {
										textAlign: "left"
									}
								}, `结束：${ endDate }` )
							]
						);
					}
				},
				{
					title: "实际停用时间",
					key: "actualStopTime",
					align: "center",
					width: 250,
					render: ( h, params ) => {
						let actualStopBegin = params.row.actualBeginDate
							? params.row.actualBeginDate
							: "";
						let actualStopEnd = params.row.actualEndDate
							? params.row.actualEndDate
							: "";
						return h(
							"div",
							[
								h( "p", {
									style: {
										textAlign: "left"
									}
								}, `开始：${ actualStopBegin }` ),
								h( "p", {
									style: {
										textAlign: "left"
									}
								}, `结束：${ actualStopEnd }` )
							]
						);
					}
				},
				{
					title: "取消时间",
					key: "cancelDate",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						return h( "div", {}, params.row.cancelDate );
					}
				},
				{
					title: "联系人",
					key: "name",
					align: "center",
					width: 200
				},
				{
					title: "停用类型",
					key: "typeName",
					align: "center",
					width: 200
				},
				{
					title: "备注",
					key: "remark",
					align: "center",
					width: 200
				},
				{
					title: "状态",
					key: "stat",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						let stat = ['新建', '开始', '结束', '停用取消(已开始)', '未开始取消'][params.row.stat];
						return h( "div", {}, stat );
					}
				},
				{
					title: "操作",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						return h( "div", [
							h(
								"Button",
								{
									props: {
										type: "error",
										size: "small"
									},
									style: {
										marginRight: "10px"
									},
									on: {
										click: () => {
											this.$Modal.confirm( {
												render: h => {
													return h(
														"div",
														[
															h( "p", {}, `确定取消停用单 ${ params.row.stopNo } 吗？` ),
															h( "p", {}, `一经确定将无法修改` )
														]
													);
												},
												onOk: () => {
													this.cancelStop( params.row.stopId );
												}
											} );
										}
									}
								},
								"取消"
							)
						] );
					}
				}
			],
			stopSheetForm: {
				createDate: defaultDate,
				expectedStopDate: [],
				city: "",
				hotSpot: "",
				hotel: "",
				room: "",
				stopNo: "",
				type: 0,
				state: "S00"
			},
			stopSheetList: {
				count: 0, //记录总数
				pageCount: 0, //页面总数
				page: 1, // 第几页
				pageSize: 10, // 每页数量
				loading: false,
				data: []
			},
			allCities: [],
			allHotSpots: [],
			allHotels: [],
			hotel: []
		};
	},
	computed: {
		hotSpots: function () {
			if ( !this.stopSheetForm.city ) {
				return this.allHotSpots;
			}
			return this.allHotSpots.filter( hotSpot => {
				return hotSpot.city == this.stopSheetForm.city;
			} );
		},
		hotels: function () {
			if ( !this.stopSheetForm.city && !this.stopSheetForm.hotSpot ) {
				return this.allHotels;
			} else if ( this.stopSheetForm.city && !this.stopSheetForm.hotSpot ) {
				return this.allHotels.filter( hotel => {
					return hotel.city == this.stopSheetForm.city;
				} )
			} else if ( !this.stopSheetForm.city && this.stopSheetForm.hotSpot ) {
				return this.allHotels.filter( hotel => {
					return hotel.parentId == this.stopSheetForm.hotSpot;
				} )
			} else {
				return this.allHotels.filter( hotel => {
					let matchCities = hotel.city == this.stopSheetForm.city;
					let matchHotSpot = hotel.parentId == this.stopSheetForm.hotSpot;
					return matchCities && matchHotSpot;
				} )
			}
		},
	},
	methods: {
		clearValue( formItemKey ) {
			if ( formItemKey == 'city' ) {
				this.stopSheetForm.hotSpot = "";
			}
			this.stopSheetForm.hotel = "";
		},
		changeDate( dateRange, formName, datePicker ) {
			if ( !dateRange[0] ) {
				this[formName][datePicker] = [];
			} else {
				let tranferDate = []
				for ( let i = 0; i < dateRange.length; i++ ) {
					let date = Moment( dateRange[i] ).format( 'YYYY-MM-DD' )
					tranferDate.push( date );
				}
				this[formName][datePicker] = tranferDate;
			}
		},
		changePage( pageIndex ) {
			this.stopSheetList.page = pageIndex;
			this.queryStopSheetList();
		},
		changePageSize( pageSize ) {
			this.stopSheetList.page = 1;
			this.stopSheetList.pageSize = pageSize;
			this.queryStopSheetList();
		},
		async cancelStop( stopId ) {
			let resp = ( await API.omsAPI[this.env].order.removeStopItem( stopId, this.token ) ).data;

			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "修改状态失败",
					desc: resp.msg
				} );
			} else {
				this.$Notice.success( {
					title: "修改状态成功"
				} );

				this.queryStopSheetListWithKeyword();
			}
		},
		queryStopSheetListWithKeyword() {
			if (
				this.stopSheetForm.createDate.join( '' ).length == 0 &&
				this.stopSheetForm.expectedStopDate.join( '' ).length == 0
			) {
				this.$Notice.error( {
					title: "创建日期、预计停用日期范围至少选其一"
				} );
				return;
			}
			this.stopSheetList.page = 1;
			this.queryStopSheetList();
		},
		async queryStopSheetList() {
			this.stopSheetList.loading = true;
			let resp = ( await this.sendQueryStopSheetList( this.stopSheetList, this.env, this.token ) ).data;
			this.stopSheetList.data = resp.result;
			// this.stopSheetList.page = resp.page;
			this.stopSheetList.count = resp.count;
			this.stopSheetList.loading = false;
		},
		sendQueryStopSheetList( stopSheetList, env, token ) {
			let params = {
				page: stopSheetList.page,
				size: stopSheetList.pageSize,
				hotspotPowerIds: this.hotspotPowerIds,
			}
			this.stopSheetForm.hotel ? params.chainId = this.stopSheetForm.hotel : "";
			this.stopSheetForm.city ? params.city = this.stopSheetForm.city : "";
			this.stopSheetForm.createDate.join( '' ).length !== 0 ? params.startDate = Moment( this.stopSheetForm.createDate[0] ).format( 'YYYY-MM-DD' ) : "";
			this.stopSheetForm.createDate.join( '' ).length !== 0 ? params.endDate = Moment( this.stopSheetForm.createDate[1] ).format( 'YYYY-MM-DD' ) : "";
			this.stopSheetForm.expectedStopDate.join( '' ).length !== 0 ? params.stopStartDate = Moment( this.stopSheetForm.expectedStopDate[0] ).format( 'YYYY-MM-DD' ) : "";
			this.stopSheetForm.expectedStopDate.join( '' ).length !== 0 ? params.stopEndDate = Moment( this.stopSheetForm.expectedStopDate[1] ).format( 'YYYY-MM-DD' ) : "",
				this.stopSheetForm.hotSpot ? params.hotspotId = this.stopSheetForm.hotSpot : "";
			this.stopSheetForm.room ? params.roomIdOrNo = this.stopSheetForm.room : "";
			this.stopSheetForm.state !== "S00" ? params.stat = this.stopSheetForm.state : "";
			this.stopSheetForm.stopNo ? params.stopNo = this.stopSheetForm.stopNo : "";
			this.stopSheetForm.type !== 0 ? params.type = this.stopSheetForm.type : "";
			return API.omsAPI[env].order.queryStopList( params, token );
		},
		async exportFilterResult() {
			if (
				this.stopSheetForm.createDate.join( '' ).length == 0 &&
				this.stopSheetForm.expectedStopDate.length == 0
			) {
				this.$Notice.error( {
					title: "创建日期、预计停用日期范围至少选其一"
				} );
				return;
			}

			if ( !( await this.checkUserPower() ) ) {
				return;
			}

			let url = Config[this.env].analysisUrl + "/excel/stopList?page=1&size=999999" +
				"&startDate=" + ( this.stopSheetForm.createDate.join( '' ).length !== 0 ? Moment( this.stopSheetForm.createDate[0] ).format( 'YYYY-MM-DD' ) : "" ) +
				"&endDate=" + ( this.stopSheetForm.createDate.join( '' ).length !== 0 ? Moment( this.stopSheetForm.createDate[1] ).format( 'YYYY-MM-DD' ) : "" ) +
				"&stopStartDate=" + ( this.stopSheetForm.expectedStopDate.join( '' ).length !== 0 ? Moment( this.stopSheetForm.expectedStopDate[0] ).format( 'YYYY-MM-DD' ) : "" ) +
				"&stopEndDate=" + ( this.stopSheetForm.expectedStopDate.join( '' ).length !== 0 ? Moment( this.stopSheetForm.expectedStopDate[1] ).format( 'YYYY-MM-DD' ) : "" ) +
				"&hotel=" + ( this.stopSheetForm.hotel ? this.stopSheetForm.hotel : "" ) +
				"&city=" + ( this.stopSheetForm.city ? this.stopSheetForm.city : "" ) +
				"&hotSpot=" + ( this.stopSheetForm.hotSpot ? this.stopSheetForm.hotSpot : "" ) +
				"&room=" + ( this.stopSheetForm.room ? this.stopSheetForm.room : "" ) +
				"&state=" + ( this.stopSheetForm.state !== "S00" ? this.stopSheetForm.state : "" ) +
				"&stopNo=" + ( this.stopSheetForm.stopNo ? this.stopSheetForm.stopNo : "" ) +
				"&type=" + ( this.stopSheetForm.type !== 0 ? this.stopSheetForm.type : "" );

			// window.open(url ,"_blank");
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, "exportBtn" )
		},
		async checkUserPower() {
			let allowResp = ( await API.omsAPI[this.env].user.queryUserPower( 'stopList', this.token ) ).data;
			if ( !allowResp.allow ) {
				this.$Notice.error( {
					title: "导出失败",
					desc: "没有权限"
				} );
				return false;
			}
			return true;
		},
		modifyInBatch() {
			// 调用angular modal
			document.querySelector( '[href="#modifyInBatch"]' ) && document.querySelector( '[href="#modifyInBatch"]' ).click();
		},
		resetStopSheetList() {
			this.stopSheetList = {
				count: 0, //记录总数
				pageCount: 0, //页面总数
				page: 1, // 第几页
				pageSize: 10, // 每页数量
				loading: false,
				data: []
			};
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/pages/order/stop-sheet.vue